import {useState} from 'react'
import {useAuthContext} from './useAuthContext'
import API_BASE_URL from '../config.js';


export const useLogin = () => {

    // We'll update this if we have an error >:(
    const [error, setError] = useState(null)
    // We can add a loading image if we want while we are attempting to sign the user in
    const [isLoading,setIsLoading] = useState(null)
    // We use this to store the global state of the login using authContext
    const {dispatch} = useAuthContext()


    // Here we are attempting our post request
    const login = async (email,password)=>{
        setIsLoading(true);
        setError(null);

        const response = await fetch(`${API_BASE_URL}/api/user/login`,
        { method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({email,password})})
        
        

        // Here we are grabbing our request
        const json = await response.json()

        // If request is bad, we return the error
        
        if(!response.ok){
            setIsLoading(false)
            setError(json.error)
        }

        // If good, we set global login state

        if(response.ok){
            localStorage.setItem('user',JSON.stringify(json))
            dispatch({type: 'LOGIN', payload: json})
            setIsLoading(false);
        }


        }

        // This hook returns the signup function, isloading, and error
    return {login, isLoading, error}    
}